/**
 * AE-207 name helpers.
 *
 * `users.first_name` / `users.last_name` are the source of truth for the profile screen,
 * while `users.user_name` is kept as the `"first last"` display value that the sidebar, the
 * hub greeting and the `profiles.user_name` copy all read.
 */

/** Build the `user_name` display value written alongside the two columns on every save. */
export function composeUserName(firstName: string, lastName?: string | null): string {
  return [firstName.trim(), (lastName ?? "").trim()].filter(Boolean).join(" ");
}

/**
 * Derive first/last from a legacy single `user_name`, splitting on the FIRST space.
 *
 * Mirrors the backfill in `20260817120000_ae207_users_first_last_name.sql` exactly, so a row
 * the migration has not reached yet reads the same way in the UI. A single token (such as the
 * email local-part placeholder written on first sign-in) becomes the first name with no last
 * name, which is what prompts the user to complete it.
 */
export function splitLegacyUserName(userName?: string | null): { firstName: string; lastName: string } {
  const trimmed = (userName ?? "").trim();
  if (!trimmed) return { firstName: "", lastName: "" };

  const boundary = trimmed.indexOf(" ");
  if (boundary === -1) return { firstName: trimmed, lastName: "" };

  return {
    firstName: trimmed.slice(0, boundary).trim(),
    lastName: trimmed.slice(boundary + 1).trim(),
  };
}
